import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import LineChart from '@components/Charts/LineChart';
import { useFilter } from '../contexts/FilterContext';
import { useEffect, useState } from 'react';

type Occupation = {
  value: string;
  code: string;
  sectorCode: string;
  EmploymentGrowth: Record<TimeRange, { name: string; value: number }[]>;
};
type TimeRange = '3 Months' | '6 Months' | '1 Year' | '3 Years';

const TotalEmploymentGrowth: React.FC = () => {
  const { selectedSector, selectedOccupation, timeRange, selectedTab } = useFilter();

  const [occupationsData, setOccupationsData] = useState<Occupation[]>([]);
useEffect(() => {
  const loadData = async () => {
    try {
      const dataModule = await import(`../json/${selectedTab}/occupations.json`);
      setOccupationsData(dataModule.default || []);
    } catch (err) {
      console.error(`Failed to load occupations for ${selectedTab}`, err);
      setOccupationsData([]);
    }
  };

  loadData();
}, [selectedTab]);





  const matchedOccupation = occupationsData.find(
    (item) =>
      (!selectedSector || item.sectorCode === selectedSector) &&
      (!selectedOccupation || item.code === selectedOccupation)
  );

  const chartData =
    matchedOccupation?.EmploymentGrowth?.[timeRange as TimeRange] || [];

  return (
    <div className="flex-grow-1 border rounded p-3 bg-white rounded" style={{ minWidth: '300px', flex: 1 }}>
      <div className="pb-4">
        <h6 className="mb-1 d-flex align-items-center gap-1" style={{ fontSize: 20 }}>
          Total Employment Growth ({timeRange} forecast)
          <Tooltip title="Shows total employment growth across all sectors over the selected time period." arrow>
            <InfoOutlined sx={{ fontSize: 16, color: '#6b7280', cursor: 'pointer' }} />
          </Tooltip>
        </h6>
        <p className="text-muted small mb-0">
          Shows total employment growth across all sectors over the selected time period.
        </p>
      </div>

      <LineChart
        name="employment-forecast"
        data={chartData}
        titleX=""
        titleY=""
      />
    </div>
  );
};

export default TotalEmploymentGrowth;
